var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7H19.5L18.6 5.8C18.2 5.3 17.6 5 16.9 5H7C6.3 5 5.7 5.3 5.3 5.8L4.5 7H2V9H3.1L2.3 10.1C2.1 10.4 2 10.7 2 11.1V17C2 18.1 2.9 19 4 19H7C7.6 19 8 18.6 8 18V17H16V18C16 18.6 16.4 19 17 19H20C20.5 19 21 18.8 21.4 18.4C21.8 18 22 17.5 22 17V11.1C22 10.7 21.9 10.4 21.7 10.1L20.9 9H22V7ZM8 14H4V12H8V14ZM5 10L6.7 7.5C6.9 7.2 7.2 7 7.5 7H16.4C16.7 7 17 7.2 17.2 7.5L19 10H12H5ZM20 14H16V12H20V14Z",
    fill: "#00000099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ce3a2658f12605008166ce5ff0306d2d.svg";
export { ForwardRef as ReactComponent };